import React from "react";
import { H2HMatchRow } from "@ihs-widget/components/StatsConsole/Widgets/H2HWidget/parts/H2H/H2HMatchRow";
import { useLanguage } from "@ihs-widget/utils/hooks/useLanguage";
import { LatestMatchesTeam } from "@ihs-widget/components/StatsConsole/Widgets/H2HWidget/parts/H2H/LatestMatchesTeam";
import { useTranslations } from "../../../../../../translation/TranslationContext";

interface ILatestMatchesListProps {
    homeTeam: string | null;
    awayTeam: string | null;
    data: any;
}

export const LatestMatchesList = ({ homeTeam, awayTeam, data }: ILatestMatchesListProps) => {
    const language = useLanguage();
    const t = useTranslations(language);

    return (
        <div data-testid="h2h-latest-matches-list-container" className="w-full flex flex-col justify-center items-center">
            <div data-testid="h2h-latest-matches-title" className='text-[12px] leading-[16px] text-highlight-light dark:text-highlight-dark font-robotoMedium font-medium w-full
                            flex justify-center items-center mb-[8px]'>{t[`InHouseStats.H2HLatestMatches`]}
            </div>
            <div data-testid="h2h-latest-matches-team-container" className="mb-[8px]">
                {homeTeam && <LatestMatchesTeam team="team_a" homeTeam={homeTeam} awayTeam={awayTeam} />}
                {awayTeam && <LatestMatchesTeam team="team_b" homeTeam={homeTeam} awayTeam={awayTeam} />}
            </div>

            {[...data]
                .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
                .map((match: any, index: number) => (
                    <H2HMatchRow 
                        key={index} 
                        date={match.date} 
                        league={match.league} 
                        homeTeam={match.homeTeam} 
                        homeScore={match.homeScore} 
                        awayScore={match.awayScore} 
                        awayTeam={match.awayTeam} 
                        status={match.status} 
                        isLatestMatch={true}
                    />
                ))}
        </div>
    )
}